<template>
	<v-card-text>
		<v-row align="center" class="my-0 mx-0">
			<v-rating
				:value="item.stars"
				color="#fd8f03"
				dense
				half-increments
				readonly
				size="15"
				class="icon-star pa-0"
			></v-rating>
			<div class="grey--text writer">
				{{ item.regrId }}
			</div>
			<div class="grey--text date">
				{{ item.regDtm }}
			</div>
			<v-spacer></v-spacer>
		</v-row>
		<div class="mt-2">
			<div v-if="item.optNm" class="desc-option">
				구매옵션 : {{ item.optNm }}
			</div>
			<div v-if="item.revwPrsn" class="mt-1 desc-row">
				<span v-if="item.revwPrsn.prsnHgt"
					><span class="tit">키</span>
					{{ item.revwPrsn.prsnHgt }}</span
				>
				<span v-if="item.revwPrsn.prsnUps">
					<span class="tit">상의</span>
					{{ item.revwPrsn.prsnUps }}</span
				>
				<span v-if="item.revwPrsn.prsnDws">
					<span class="tit">하의</span>
					{{ item.revwPrsn.prsnDws }}</span
				>
			</div>
		</div>
		<v-row class="mx-0 my-4 desc-wrap"
			><span v-if="item.revwTyp == 'OneMonnRevw'" class="month-bdg">
				한달사용
			</span>
			<span v-html="item.prdrevwBody" class="desc-txt"></span
		></v-row>

		<div v-if="item.evalInfoList" class="desc-box desc-column">
			<div v-for="(d, i) in item.evalInfoList" :key="i" class="desc-item">
				<span class="tit">{{ d.evalItmNm }}</span>
				{{ d.evalItmVal }}
			</div>
		</div>
	</v-card-text>
</template>


<script>
import { APP_URL } from "../api/index";
import store from "@/store";
export default {
	name: "RevwBody",
	props: {
		item: Object,
	},
	data() {
		return {
			continuousdata: false,
			currIdx: 0,
			totalCount:
				store.state.totalCnt > 999
					? store.state.items.length > 999
						? store.state.items.length + "+"
						: "999+"
					: store.state.totalCnt,
			images: store.state.items,
			loadFlag: true,

			firstPlay: false,
			videoShowFlags: {},
			startX: 0,
			startY: 0,
			isSwiping: false,
			isRcmdShow: true,
		};
	},
	computed: {
		thumbIcon() {
			return store.state.items[this.currIdx]
				? store.state.items[this.currIdx].rcmdFlg == "Y"
					? "icon-thumb-on"
					: "icon-thumb"
				: "N";
		},
	},
	methods: {
		reportLink() {
			return (
				"/report/" +
				this.$route.params.prdcd +
				"/" +
				this.$route.params.messageId
			);
		},
		async rcmdSubmit() {
			if ("Y" == store.state.loginYn) {
				const submitRcmd = await store.dispatch("SUBMIT_RCMD", {
					prdcd: this.$route.params.prdcd,
					messageId: this.images[this.currIdx].messageId,
					myRevwFlg: this.images[this.currIdx].myRevwFlg,
					rcmdFlg: this.images[this.currIdx].rcmdFlg,
					oppstFlg: "N",
					index: this.currIdx,
				});
				this.goodRevwClick();
			} else {
				var loginUrl =
					APP_URL + "/member/logIn.gs?returnurl=" + location.href;
				if ("Y" == store.state.appYn) {
					loginUrl = "toapp://login?param=" + location.href;
				}
				location.href = loginUrl;
			}
		},
		goodRevwClick() {
			sendAmplitudeCodeAction(
				store.state.prdcd,
				"",
				"",
				"상품평_목록_" +
					(this.images[this.currIdx].revwTyp == "OneMonnRevw"
						? "한달"
						: "일반") +
					"_도움돼요",
				true
			);
		},
	},
};
</script>

<style lang="scss">
.v-image__image--preload {
	filter: blur(0);
}

* {
	touch-action: manipulation;
}
</style>
